import { Routes } from '@angular/router';
import { NavigationItem } from '../context/current-context.model';
import { RouteRegistryEntry } from './navigation-route-registry';
import { PlannedModulePlaceholderComponent } from '../../features/planned/planned-module-placeholder.component';

export interface PlaceholderScreenDef {
  path: string;
  menuKey: string;
  labelKey: string;
  titleKey: string;
  descriptionKey?: string;
  roadmapKey?: string;
  suiteKey: string;
  moduleKey: string;
  capabilityKey: string;
  sortOrder: number;
  requiredPermission?: string | null;
  requiredEntitlement?: string | null;
}

export function buildPlaceholderRoutes(defs: PlaceholderScreenDef[]): Routes {
  return defs.map(def => ({
    path: def.path,
    component: PlannedModulePlaceholderComponent,
    data: {
      requiredScopes: ['admin'],
      plannedTitleKey: def.titleKey,
      plannedDescriptionKey: def.descriptionKey ?? 'nav.placeholder.description',
      ...(def.roadmapKey ? { plannedRoadmapKey: def.roadmapKey } : {})
    }
  }));
}

export function buildSupplementalItems(defs: PlaceholderScreenDef[]): NavigationItem[] {
  return defs.map(def => ({
    key: def.menuKey,
    label: def.labelKey,
    route: `/${def.path}`,
    moduleKey: def.moduleKey,
    requiredEntitlement: def.requiredEntitlement ?? null,
    requiredPermission: def.requiredPermission ?? null,
    sortOrder: def.sortOrder,
    suiteKey: def.suiteKey,
    moduleKeyCanonical: def.moduleKey,
    capabilityKey: def.capabilityKey,
    level: 4,
    status: 'active' as const
  }));
}

export function buildRouteRegistryEntries(defs: PlaceholderScreenDef[]): RouteRegistryEntry[] {
  return defs.map(def => ({ route: `/${def.path}` }));
}
